export default __webpack_public_path__ + "static/media/img-book.6a9cc805.png";